import { initializeApp } from 'firebase/app'
import { getAuth, RecaptchaVerifier } from 'firebase/auth'
import { initializeAppCheck, ReCaptchaEnterpriseProvider, getToken } from 'firebase/app-check'

// Firebase-konfig for Spelaren Partner (prosjekt: spelaren-2025).
// Web-config er offentlig. REACT_APP_* overstyrer defaultene ved behov.
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'AIzaSyCjKByhYuueaO2p9jYlP51dcSx_KkUPWUU',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'spelaren-2025.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'spelaren-2025',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'spelaren-2025.firebasestorage.app',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '536101167141',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '1:536101167141:web:da85cb5b45a6773aa25fcc'
}

const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY || '6LdNtlEsAAAAAB_OPMecWzFib0rj4EYKDdRuu5gf'

const isFirebaseConfigured =
  firebaseConfig.apiKey &&
  firebaseConfig.apiKey !== 'your-api-key' &&
  firebaseConfig.authDomain &&
  firebaseConfig.projectId

if (!isFirebaseConfigured) {
  console.warn(
    'Firebase er ikke konfigurert. Opprett .env med REACT_APP_FIREBASE_* verdier for at innlogging skal fungere.'
  )
}

let app = null
let appCheck = null
let appCheckInitStarted = false

try {
  if (isFirebaseConfigured) {
    app = initializeApp(firebaseConfig)
  }
} catch (error) {
  console.error('Feil ved Firebase-initialisering:', error)
  app = null
}

function ensureAppCheckInitialized() {
  if (appCheckInitStarted || !app) return
  appCheckInitStarted = true
  try {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(RECAPTCHA_SITE_KEY),
      isTokenAutoRefreshEnabled: true
    })
  } catch (appCheckError) {
    console.warn('App Check-initialisering feilet:', appCheckError)
  }
}

export const auth = app ? getAuth(app) : null

export const getAppCheckToken = async () => {
  ensureAppCheckInitialized()
  if (!appCheck) return null
  try {
    const tokenResult = await getToken(appCheck, false)
    return tokenResult.token
  } catch (error) {
    console.warn('Kunne ikke hente App Check-token:', error)
    return null
  }
}

export const setupRecaptcha = (elementId = 'recaptcha-container') => {
  if (!auth) {
    throw new Error('Firebase er ikke konfigurert. Sjekk .env-filen.')
  }
  const existing = document.getElementById(elementId)
  if (existing) existing.innerHTML = ''
  return new RecaptchaVerifier(auth, elementId, {
    size: 'invisible',
    callback: () => {},
    'expired-callback': () => console.error('reCAPTCHA expired')
  })
}

export { appCheck }
export default app
